import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TemplateBean } from '../../beans/templateBean';
import { EditorComponent } from '@progress/kendo-angular-editor';

@Component({
  selector: 'app-plain-text',
  templateUrl: './plain-text.component.html',
  styleUrls: ['./plain-text.component.scss'],
  standalone: false
})
export class PlainTextComponent {
  @ViewChild(EditorComponent) kendoEditor!: EditorComponent;
  @Input() plainTxtData!: TemplateBean;

  @Output() onPlainTxtContentChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() plainTxtUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

  loading = true;
  plainTxtContent: any;
  formData = {
    mail_name: '',
    mail_from: '',
    mail_subject: ''
  }

  htmlContent!: string;
  mail_content: any;

  constructor(private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.plainTxtContent = this.plainTxtData.content;
    this.onPlainTxtContentChange.emit({ ...this.plainTxtData });
  }

  onEditorChange(content: string) {
    this.plainTxtData = { ...this.plainTxtData, content: content };
    this.onPlainTxtContentChange.emit(this.plainTxtData);
    this.plainTxtUpdated.emit(true);
    this.cdr.detectChanges();
  }

  onEmailFormChange(formData: any) {
    this.plainTxtData = { ...this.plainTxtData, ...formData };
    this.onPlainTxtContentChange.emit(this.plainTxtData);
    this.plainTxtUpdated.emit(true);
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['plainTxtData'] && changes['plainTxtData'].currentValue) {
      const { content, mail_name, mail_from, mail_subject } = this.plainTxtData;
      this.plainTxtContent = content;
      this.formData = { mail_name, mail_from, mail_subject };
      this.loading = false;
      this.cdr.detectChanges();
    } else {
      this.plainTxtContent = '';
      this.formData = {
        mail_name: '',
        mail_from: '',
        mail_subject: ''
      };
    }
  }
}

